module.exports = __webpack_public_path__ + "img/katja-wolter.4baf4813.jpg";